import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const TXT = {
  en: { h1: 'Page not found', sub: 'The page you are looking for does not exist or has moved.', cta: 'Open the Cursive Generator', home: '/' },
  fr: { h1: 'Page introuvable', sub: 'La page que vous cherchez n’existe pas ou a été déplacée.', cta: 'Ouvrir le générateur d’écriture cursive', home: '/fr/ecriture-cursive' },
};

// Served by Cloudflare Pages with a real 404 status (build/404.html).
export default function NotFound() {
  const { pathname } = useLocation();
  const L = pathname.toLowerCase().startsWith('/fr/') ? TXT.fr : TXT.en;
  return (
    <div className="max-w-[1000px] mx-auto px-5 py-16 text-center" data-testid="not-found-page">
      <h1 className="font-hand text-[40px] text-slate-900">{L.h1}</h1>
      <p className="text-[15px] text-slate-600 mt-3">{L.sub}</p>
      <Link to={L.home} className="btn-gold !no-underline inline-block !text-white mt-8" data-testid="not-found-cta">{L.cta}</Link>
    </div>
  );
}
